import { render, staticRenderFns } from "./lessonLink.vue?vue&type=template&id=6c5d1f52&"
import script from "./lessonLink.vue?vue&type=script&lang=js&"
export * from "./lessonLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports